import { arc } from 'd3-shape';
import { min, sum } from 'd3-array';
import { convertDegreesToRadians } from '@keen.io/charts-utils';
import { calculateColorScale } from '../../../utils/colors.utils';
import { MAX_DEGREES, INNER_WIDTH, OUTER_WIDTH, DEFAULT_MIN, DEFAULT_MAX, } from '../constants';
export var generateGauge = function (_a) {
    var data = _a.data, valueKey = _a.valueKey, dimension = _a.dimension, margins = _a.margins, startAngle = _a.startAngle, endAngle = _a.endAngle, minValue = _a.minValue, maxValue = _a.maxValue, colors = _a.colors, colorMode = _a.colorMode, colorSteps = _a.colorSteps;
    var width = dimension.width, height = dimension.height;
    var radius = min([
        width / 2 - margins.left - margins.right,
        height / 2 - margins.top - margins.bottom,
    ]);
    var progressValue = sum(data.map(function (item) { return item[valueKey]; }));
    var minimum = minValue === 'auto' ? DEFAULT_MIN : minValue;
    var maximum = maxValue === 'auto' ? DEFAULT_MAX : maxValue;
    var colorMin = colorMode === 'discrete' ? minimum : startAngle;
    var colorMax = colorMode === 'discrete' ? maximum : endAngle;
    var getColor = calculateColorScale(colorMin, colorMax, colorMode, colorSteps, colors);
    var arcStartAngle = convertDegreesToRadians(startAngle);
    var arcEndAngle = convertDegreesToRadians(endAngle);
    var arcProperties = {
        startAngle: arcStartAngle,
        endAngle: arcEndAngle,
    };
    var drawInnerArcPath = arc()
        .innerRadius(radius - INNER_WIDTH)
        .outerRadius(radius - OUTER_WIDTH);
    var innerArcs = [];
    var maximumValue = maximum - minimum;
    var currentPercent = ((progressValue - minimum) / maximumValue) * 100;
    var arcRange = Math.abs(startAngle) + endAngle;
    var progressMaxAngle = currentPercent >= 100
        ? endAngle
        : startAngle + Math.round((currentPercent * arcRange) / 100);
    for (var i = startAngle; i <= progressMaxAngle - 1; i++) {
        var props = {
            startAngle: convertDegreesToRadians(i),
            endAngle: convertDegreesToRadians(i + 1),
        };
        var path = drawInnerArcPath(props);
        innerArcs.push({
            path: path,
            color: getColor(colorMode === 'discrete' ? progressValue : i),
            value: minimum +
                (Math.round(((i + endAngle) / arcRange) * 100) * maximumValue) / 100,
        });
    }
    var outerArcPath = arc()
        .innerRadius(radius - OUTER_WIDTH)
        .outerRadius(radius)(arcProperties);
    var emptySpaceArcPath = arc()
        .innerRadius(radius - OUTER_WIDTH)
        .outerRadius(radius)({
        startAngle: arcEndAngle,
        endAngle: convertDegreesToRadians(MAX_DEGREES - endAngle),
    });
    return {
        innerArcs: innerArcs,
        minimum: minimum,
        maximum: maximum,
        progressValue: progressValue,
        emptySpaceArcPath: emptySpaceArcPath,
        outerArcPath: outerArcPath,
    };
};
